import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { Button } from 'semantic-ui-react';
import { deviceBreakpoints } from 'variables';
import { dynamicStyles } from 'utils/resuable-css';

export const HeaderSC = styled.div`
  display: flex;
  background: ${(props) => props.theme.gray.shadeF};
  height: ${(props) => props.theme.default?.top_bar_height};
  ${(props) => dynamicStyles(props.theme.resolutions, 'top_bar_height', 'height')};
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid ${(props) => props.theme.dividerColor};

  @media only screen and (max-width: ${deviceBreakpoints.mLaptop}px) {
    box-shadow: ${(props) => props.theme.boxShadow1};
    border-bottom: 1px solid ${(props) => props.theme.gray.shade0};
    z-index: 1000;
    right: 0;
    left: 0;
    position: fixed;
  }
`;

export const AppDrawerToggleButton = styled.div`
  display: none;
  border-right: 1px solid ${(props) => props.theme.dividerColor};
  font-size: 24px;
  line-height: 24px;
  height: 100%;
  padding: 0 4px;
  color: ${(props) => props.theme.gray.shade0};
  align-items: center;
  justify-content: center;
  cursor: pointer;

  i {
    margin-right: 0;
  }

  @media only screen and (max-width: ${deviceBreakpoints.mLaptop}px) {
    display: flex;
  }
`;

export const LeftHeader = styled.div`
  display: grid;
  margin-left: 20px;
  gap: 5px;

  @media only screen and (max-width: ${deviceBreakpoints.mLaptop}px) {
    display: none;
  }
`;

export const Para = styled.div`
  display: inline;
  font-size: ${(props) => props.theme.default?.top_bar_font};
  ${(props) => dynamicStyles(props.theme.resolutions, 'top_bar_font', 'font-size')};
`;

export const ChangelogLink = styled(Link)`
  color: ${(props) => props.theme.primaryDarkColor};
  font-weight: bold;
  text-decoration: none;
  margin-left: 5px;
  &:hover {
    text-decoration: underline;
  }
`;

export const Text = styled.span`
  a {
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
`;

export const ButtonSC = styled(Button)`
  &&& {
    display: inline-block;
    padding: 6px 8px;
  }
`;

export const RightHeader = styled.span`
  display: flex;
  height: ${(props) => props.theme.default?.top_bar_height};
  ${(props) => dynamicStyles(props.theme.resolutions, 'top_bar_height', 'height')};

  @media only screen and (max-width: ${deviceBreakpoints.mLaptop}px) {
    justify-content: space-between;
  }
`;

export const TestimonialContainer = styled.a`
  display: grid;
  gap: 5px;
  justify-items: center;
  align-content: center;
  padding: 0 20px;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }

  @media only screen and (max-width: ${deviceBreakpoints.phone}px) {
    justify-items: start;
    padding: 0 10px;
  }
`;

export const Stars = styled.img`
  height: 32px;

  @media only screen and (max-width: ${deviceBreakpoints.phone}px) {
    height: 26px;
  }
`;

export const TestimonialText = styled.div`
  display: flex;
  font-size: 14px;
`;

export const SocialMediaLink = styled(Link)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: ${(props) => props.theme.gray.shade0};
  border-left: 1px solid ${(props) => props.theme.dividerColor};
  padding-left: 20px;
  padding-right: 10px;
  padding-top: 4px;
  &:hover {
    color: ${(props) => props.theme.gray.shade0};
  }
  .logout {
    font-size: ${(props) => props.theme.default?.top_bar_right_icon_font};
    ${(props) => dynamicStyles(props.theme.resolutions, 'top_bar_right_icon_font', 'font-size')};
    padding-right: 10px;
    font-weight: bold;
    color: black;
  }
  i {
    font-size: ${(props) => props.theme.default?.top_bar_right_icon_width};
    ${(props) => dynamicStyles(props.theme.resolutions, 'top_bar_right_icon_width', 'font-size')};
    color: black;
  }
`;

export const Search = styled.div`
  margin-right: 10px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`;

export const SearchCategory = styled.div`
  h6 {
    margin: 0 10px;
    margin-top: 0.5em;
  }
  .link-description {
    display: flex;
    padding: 8px 2em;
    border-bottom: 1px solid ${(props) => props.theme.dividerColor};
  }
`;

export const TriggerContainer = styled.div`
  display: grid;
  justify-items: center;
  align-content: center;
  cursor: pointer;
  width: 6.5em;
  &:hover {
    text-decoration: underline;
  }
  .user-icon {
    font-size: ${(props) => props.theme.default?.top_bar_right_icon_width};
    width: ${(props) => props.theme.default?.top_bar_right_icon_width};
    height: ${(props) => props.theme.default?.top_bar_right_icon_height};
    ${(props) => dynamicStyles(props.theme.resolutions, 'top_bar_right_icon_width', 'font-size')};
    margin: 1px 0px 2px 0px;
  }
`;

export const AccountLabel = styled.div`
  display: inline;
  font-size: ${(props) => props.theme.default?.top_bar_right_icon_font};
  font-weight: bold;
  color: ${(props) => props.theme.gray.shade10};

  i {
    margin-left: 2px;
  }
  ${(props) => dynamicStyles(props.theme.resolutions, 'top_bar_right_icon_font', 'font-size')};
`;

export const SearchContainer = styled.div`
  background: white;
  position: absolute;
  border-radius: 5px;
  z-index: 10000;
  top: ${(props) => props.theme.default?.top_bar_height};
  ${(props) => dynamicStyles(props.theme.resolutions, 'top_bar_height', 'top')};
  overflow-y: scroll;
  box-shadow: lightgray 0px 0px 24px 5px;
  .link {
    display: flex;
    padding: 8px 2em;
    border-bottom: 1px solid ${(props) => props.theme.dividerColor};
  }
  p {
    margin: 0;
    color: black;
    cursor: pointer;
  }
  i {
    color: black;
    font-size: 8px;
    margin-top: 1px;
    margin-right: 12px;
  }
`;

export const LanguageSwitcher = styled.div`
  display: flex;
  margin: 0 1em;
  align-items: center;
`;
